import { GetWorkV2Find } from '@mzic/mzic-interfaces';

export const worksMockData: GetWorkV2Find = {
  timestamp: new Date('2025-10-04T23:52:45.392277853Z'),
  status: 'success',
  data: {
    content: [
      {
        id: 1,
        title: 'Bohemian Rhapsody',
        composerNames: 'Freddie Mercury',
        societyRegistrations: [
          {
            royaltyEntity: 'ECAD',
            cwrId: 'T-070.604.720-3',
          },
          {
            royaltyEntity: 'ABRAMUS',
            cwrId: 'W-123456789-0',
          },
          {
            royaltyEntity: 'ABRAMUS_DIGITAL',
            cwrId: 'D-987654321-1',
          },
        ],
        iswc: 'T-070.604.720-3',
        explicit: false,
        associatedTracks: [
          {
            id: 101,
            isrc: 'GBUM71029604',
            hash: '',
            title: 'Bohemian Rhapsody',
            titleVersion: 'Original Version',
            primaryGenre: {
              id: 15,
              name: 'Rock',
            },
            secondaryGenre: {
              id: 28,
              name: 'Progressive Rock',
            },
            label: {
              id: 5,
              imageId: 'queen-label-001',
              name: 'EMI Records',
              description: 'British record label',
            },
            releaseDate: '1975-10-31',
            artistNames: 'Queen',
            releaseType: 'ALBUM',
            status: 'READY',
          },
          {
            id: 102,
            isrc: 'GBUM71029605',
            hash: '',
            title: 'Bohemian Rhapsody',
            titleVersion: '2011 Remaster',
            primaryGenre: {
              id: 15,
              name: 'Rock',
            },
            secondaryGenre: {
              id: 28,
              name: 'Progressive Rock',
            },
            label: {
              id: 5,
              imageId: 'queen-label-002',
              name: 'Hollywood Records',
              description: 'Remastered edition',
            },
            releaseDate: '2011-09-05',
            artistNames: 'Queen',
            releaseType: 'ALBUM',
            status: 'READY',
          },
        ],
        rightsSaleStatus: {
          total: 2,
          ready: 2,
          inInspection: 0,
          processing: 0,
          scheduledToDrop: 0,
          primaryMarket: 1,
          secondaryMarket: 1,
          failed: 0,
          sales: [],
          status: null,
        },
        publishingStatus: {
          execution: [
            {
              cwrId: 'W-123456789-0',
              royaltyEntity: 'ABRAMUS',
              iconUrl: 'abramus-icon-hash',
              scope: 'BR',
              status: 'ACTIVE',
              lastUpdateAt: '2024-08-15T10:30:00Z',
            },
          ],
          streamingPublishingShare: [
            {
              cwrId: 'D-987654321-1',
              royaltyEntity: 'ABRAMUS_DIGITAL',
              scope: 'BR',
              status: 'ACTIVE',
              lastUpdateAt: '2024-08-15T10:30:00Z',
            },
          ],
          status: 'ACTIVE',
        },
      },
      {
        id: 2,
        title: 'Imagine',
        composerNames: 'John Lennon x Yoko Ono',
        societyRegistrations: [
          {
            royaltyEntity: 'ECAD',
            cwrId: 'T-010.234.567-8',
          },
          {
            royaltyEntity: 'ABRAMUS',
            cwrId: 'W-234567890-1',
          },
        ],
        iswc: 'T-010.234.567-8',
        explicit: false,
        associatedTracks: [
          {
            id: 201,
            isrc: 'GBAYE0601498',
            hash: '',
            title: 'Imagine',
            titleVersion: 'Original Album Version',
            primaryGenre: {
              id: 22,
              name: 'Pop',
            },
            secondaryGenre: {
              id: 15,
              name: 'Rock',
            },
            label: {
              id: 8,
              imageId: 'apple-records-001',
              name: 'Apple Records',
              description: "The Beatles' record label",
            },
            releaseDate: '1971-09-09',
            artistNames: 'John Lennon',
            releaseType: 'ALBUM',
            status: 'READY',
          },
        ],
        rightsSaleStatus: {
          total: 1,
          ready: 0,
          inInspection: 1,
          processing: 0,
          scheduledToDrop: 0,
          primaryMarket: 0,
          secondaryMarket: 0,
          failed: 0,
          sales: [],
          status: null,
        },
        publishingStatus: {
          execution: [
            {
              cwrId: 'W-234567890-1',
              royaltyEntity: 'ABRAMUS',
              iconUrl: 'abramus-icon-hash',
              scope: 'BR',
              status: 'REGISTRATION_IN_PROGRESS',
              lastUpdateAt: '2025-10-03T14:20:00Z',
            },
          ],
          streamingPublishingShare: [],
          status: 'REGISTRATION_IN_PROGRESS',
        },
      },
      {
        id: 3,
        title: 'Yesterday',
        composerNames: 'Paul McCartney x John Lennon',
        societyRegistrations: [
          {
            royaltyEntity: 'ECAD',
            cwrId: 'T-045.678.901-2',
          },
          {
            royaltyEntity: 'ABRAMUS',
            cwrId: 'W-345678901-2',
          },
          {
            royaltyEntity: 'ABRAMUS_DIGITAL',
            cwrId: 'D-876543210-2',
          },
        ],
        iswc: 'T-045.678.901-2',
        explicit: false,
        associatedTracks: [
          {
            id: 301,
            isrc: 'GBAYE0601349',
            hash: '',
            title: 'Yesterday',
            titleVersion: 'Remastered 2009',
            primaryGenre: {
              id: 22,
              name: 'Pop',
            },
            secondaryGenre: {
              id: 15,
              name: 'Rock',
            },
            label: {
              id: 12,
              imageId: 'parlophone-001',
              name: 'Parlophone',
              description: 'EMI subsidiary',
            },
            releaseDate: '1965-08-06',
            artistNames: 'The Beatles',
            releaseType: 'ALBUM',
            status: 'READY',
          },
          {
            id: 302,
            isrc: 'GBAYE0601350',
            hash: '',
            title: 'Yesterday',
            titleVersion: 'Anthology 2 Version',
            primaryGenre: {
              id: 22,
              name: 'Pop',
            },
            secondaryGenre: {
              id: 15,
              name: 'Rock',
            },
            label: {
              id: 12,
              imageId: 'parlophone-002',
              name: 'Parlophone',
              description: 'Anthology series',
            },
            releaseDate: '1996-03-18',
            artistNames: 'The Beatles',
            releaseType: 'ALBUM',
            status: 'READY',
          },
        ],
        rightsSaleStatus: {
          total: 2,
          ready: 1,
          inInspection: 0,
          processing: 1,
          scheduledToDrop: 0,
          primaryMarket: 1,
          secondaryMarket: 0,
          failed: 0,
          sales: [],
          status: null,
        },
        publishingStatus: {
          execution: [
            {
              cwrId: 'W-345678901-2',
              royaltyEntity: 'ABRAMUS',
              iconUrl: 'abramus-icon-hash',
              scope: 'BR',
              status: 'WORK_REGISTRATION_IN_PROGRESS',
              lastUpdateAt: '2025-10-04T09:15:00Z',
            },
          ],
          streamingPublishingShare: [
            {
              cwrId: 'D-876543210-2',
              royaltyEntity: 'ABRAMUS_DIGITAL',
              scope: 'BR',
              status: 'WORK_REGISTRATION_IN_PROGRESS',
              lastUpdateAt: '2025-10-04T09:15:00Z',
            },
          ],
          status: 'WORK_REGISTRATION_IN_PROGRESS',
        },
      },
      {
        id: 4,
        title: 'Billie Jean',
        composerNames: 'Michael Jackson',
        societyRegistrations: [
          {
            royaltyEntity: 'ECAD',
            cwrId: 'T-089.012.345-6',
          },
        ],
        iswc: 'T-089.012.345-6',
        explicit: false,
        associatedTracks: [
          {
            id: 401,
            isrc: 'USSM18200563',
            hash: '',
            title: 'Billie Jean',
            titleVersion: 'Album Version',
            primaryGenre: {
              id: 22,
              name: 'Pop',
            },
            secondaryGenre: {
              id: 35,
              name: 'R&B',
            },
            label: {
              id: 15,
              imageId: 'epic-records-001',
              name: 'Epic Records',
              description: 'Sony Music label',
            },
            releaseDate: '1982-11-30',
            artistNames: 'Michael Jackson',
            releaseType: 'ALBUM',
            status: 'READY',
          },
          {
            id: 402,
            isrc: 'USSM18200564',
            hash: '',
            title: 'Billie Jean',
            titleVersion: 'Single Edit',
            primaryGenre: {
              id: 22,
              name: 'Pop',
            },
            secondaryGenre: {
              id: 35,
              name: 'R&B',
            },
            label: {
              id: 15,
              imageId: 'epic-records-002',
              name: 'Epic Records',
              description: '7-inch single release',
            },
            releaseDate: '1983-01-02',
            artistNames: 'Michael Jackson',
            releaseType: 'SINGLE',
            status: 'READY',
          },
        ],
        rightsSaleStatus: {
          total: 2,
          ready: 1,
          inInspection: 0,
          processing: 0,
          scheduledToDrop: 0,
          primaryMarket: 0,
          secondaryMarket: 0,
          failed: 1,
          sales: [],
          status: 'ERROR',
        },
        publishingStatus: {
          execution: [
            {
              cwrId: null,
              royaltyEntity: 'ABRAMUS',
              iconUrl: 'abramus-icon-hash',
              scope: 'BR',
              status: 'WORK_REGISTRATION_FAILED',
              lastUpdateAt: '2025-09-28T16:45:00Z',
            },
          ],
          streamingPublishingShare: [],
          status: 'WORK_REGISTRATION_FAILED',
        },
      },
      {
        id: 5,
        title: 'Stairway to Heaven',
        composerNames: 'Jimmy Page x Robert Plant',
        societyRegistrations: [
          {
            royaltyEntity: 'ECAD',
            cwrId: 'T-123.456.789-0',
          },
          {
            royaltyEntity: 'ABRAMUS',
            cwrId: 'W-456789012-3',
          },
          {
            royaltyEntity: 'ABRAMUS_DIGITAL',
            cwrId: 'D-765432109-3',
          },
        ],
        iswc: 'T-123.456.789-0',
        explicit: false,
        associatedTracks: [
          {
            id: 501,
            isrc: 'USRC17607839',
            hash: '',
            title: 'Stairway to Heaven',
            titleVersion: 'Original Album Mix',
            primaryGenre: {
              id: 15,
              name: 'Rock',
            },
            secondaryGenre: {
              id: 33,
              name: 'Hard Rock',
            },
            label: {
              id: 20,
              imageId: 'atlantic-records-001',
              name: 'Atlantic Records',
              description: 'Warner Music Group',
            },
            releaseDate: '1971-11-08',
            artistNames: 'Led Zeppelin',
            releaseType: 'ALBUM',
            status: 'READY',
          },
        ],
        rightsSaleStatus: {
          total: 1,
          ready: 0,
          inInspection: 0,
          processing: 0,
          scheduledToDrop: 0,
          primaryMarket: 0,
          secondaryMarket: 0,
          failed: 1,
          sales: [],
          status: 'ERROR',
        },
        publishingStatus: {
          execution: [
            {
              cwrId: 'W-456789012-3',
              royaltyEntity: 'ABRAMUS',
              iconUrl: 'abramus-icon-hash',
              scope: 'BR',
              status: 'UPDATE_FAILED',
              lastUpdateAt: '2025-10-02T11:20:00Z',
            },
          ],
          streamingPublishingShare: [
            {
              cwrId: 'D-765432109-3',
              royaltyEntity: 'ABRAMUS_DIGITAL',
              scope: 'BR',
              status: 'UPDATE_FAILED',
              lastUpdateAt: '2025-10-02T11:20:00Z',
            },
          ],
          status: 'UPDATE_FAILED',
        },
      },
      {
        id: 6,
        title: 'Hey Jude',
        composerNames: 'Paul McCartney x John Lennon feat. The Beatles',
        societyRegistrations: [
          {
            royaltyEntity: 'ECAD',
            cwrId: 'T-234.567.890-1',
          },
          {
            royaltyEntity: 'ABRAMUS',
            cwrId: 'W-567890123-4',
          },
        ],
        iswc: 'T-234.567.890-1',
        explicit: false,
        associatedTracks: [
          {
            id: 601,
            isrc: 'GBAYE0601351',
            hash: '',
            title: 'Hey Jude',
            titleVersion: 'Single Version',
            primaryGenre: {
              id: 22,
              name: 'Pop',
            },
            secondaryGenre: {
              id: 15,
              name: 'Rock',
            },
            label: {
              id: 12,
              imageId: 'apple-records-002',
              name: 'Apple Records',
              description: 'Beatles original label',
            },
            releaseDate: '1968-08-26',
            artistNames: 'The Beatles',
            releaseType: 'SINGLE',
            status: 'READY',
          },
        ],
        rightsSaleStatus: {
          total: 1,
          ready: 1,
          inInspection: 0,
          processing: 0,
          scheduledToDrop: 0,
          primaryMarket: 1,
          secondaryMarket: 0,
          failed: 0,
          sales: [],
          status: null,
        },
        publishingStatus: {
          execution: [
            {
              cwrId: 'W-567890123-4',
              royaltyEntity: 'ABRAMUS',
              iconUrl: 'abramus-icon-hash',
              scope: 'BR',
              status: 'UPDATE_IN_PROGRESS',
              lastUpdateAt: '2025-10-04T15:30:00Z',
            },
          ],
          streamingPublishingShare: [],
          status: 'UPDATE_IN_PROGRESS',
        },
      },
      {
        id: 7,
        title: 'Hotel California',
        composerNames: 'Don Felder x Don Henley x Glenn Frey',
        societyRegistrations: [
          {
            royaltyEntity: 'ECAD',
            cwrId: 'T-345.678.901-2',
          },
          {
            royaltyEntity: 'ABRAMUS',
            cwrId: 'W-678901234-5',
          },
          {
            royaltyEntity: 'ABRAMUS_DIGITAL',
            cwrId: 'D-654321098-4',
          },
        ],
        iswc: 'T-345.678.901-2',
        explicit: false,
        associatedTracks: [
          {
            id: 701,
            isrc: 'USEE10001993',
            hash: '',
            title: 'Hotel California',
            titleVersion: 'Album Version',
            primaryGenre: {
              id: 15,
              name: 'Rock',
            },
            secondaryGenre: {
              id: 42,
              name: 'Classic Rock',
            },
            label: {
              id: 18,
              imageId: 'asylum-records-001',
              name: 'Asylum Records',
              description: 'Warner Music Group',
            },
            releaseDate: '1976-12-08',
            artistNames: 'Eagles',
            releaseType: 'ALBUM',
            status: 'READY',
          },
          {
            id: 702,
            isrc: 'USEE10001994',
            hash: '',
            title: 'Hotel California',
            titleVersion: 'Hell Freezes Over',
            primaryGenre: {
              id: 15,
              name: 'Rock',
            },
            secondaryGenre: {
              id: 42,
              name: 'Classic Rock',
            },
            label: {
              id: 18,
              imageId: 'geffen-records-001',
              name: 'Geffen Records',
              description: 'Live version',
            },
            releaseDate: '1994-11-08',
            artistNames: 'Eagles',
            releaseType: 'ALBUM',
            status: 'READY',
          },
        ],
        rightsSaleStatus: {
          total: 2,
          ready: 2,
          inInspection: 0,
          processing: 0,
          scheduledToDrop: 0,
          primaryMarket: 2,
          secondaryMarket: 0,
          failed: 0,
          sales: [],
          status: null,
        },
        publishingStatus: {
          execution: [
            {
              cwrId: 'W-678901234-5',
              royaltyEntity: 'ABRAMUS',
              iconUrl: 'abramus-icon-hash',
              scope: 'BR',
              status: 'ACTIVE',
              lastUpdateAt: '2024-12-10T08:00:00Z',
            },
          ],
          streamingPublishingShare: [
            {
              cwrId: 'D-654321098-4',
              royaltyEntity: 'ABRAMUS_DIGITAL',
              scope: 'BR',
              status: 'ACTIVE',
              lastUpdateAt: '2024-12-10T08:00:00Z',
            },
          ],
          status: 'ACTIVE',
        },
      },
      {
        id: 8,
        title: 'Like a Rolling Stone',
        composerNames: 'Bob Dylan',
        societyRegistrations: [
          {
            royaltyEntity: 'ECAD',
            cwrId: 'T-456.789.012-3',
          },
        ],
        iswc: 'T-456.789.012-3',
        explicit: false,
        associatedTracks: [
          {
            id: 801,
            isrc: 'USSM16500123',
            hash: '',
            title: 'Like a Rolling Stone',
            titleVersion: 'Album Version',
            primaryGenre: {
              id: 15,
              name: 'Rock',
            },
            secondaryGenre: {
              id: 45,
              name: 'Folk Rock',
            },
            label: {
              id: 25,
              imageId: 'columbia-records-001',
              name: 'Columbia Records',
              description: 'Sony Music',
            },
            releaseDate: '1965-08-30',
            artistNames: 'Bob Dylan',
            releaseType: 'ALBUM',
            status: 'READY',
          },
        ],
        rightsSaleStatus: {
          total: 1,
          ready: 1,
          inInspection: 0,
          processing: 0,
          scheduledToDrop: 0,
          primaryMarket: 1,
          secondaryMarket: 0,
          failed: 0,
          sales: [],
          status: null,
        },
        publishingStatus: {
          execution: [],
          streamingPublishingShare: [],
          status: 'INACTIVE',
        },
      },
      {
        id: 9,
        title: 'Smells Like Teen Spirit',
        composerNames: 'Kurt Cobain x Krist Novoselic x Dave Grohl feat. Nirvana',
        societyRegistrations: [
          {
            royaltyEntity: 'ECAD',
            cwrId: 'T-567.890.123-4',
          },
          {
            royaltyEntity: 'ABRAMUS',
            cwrId: 'W-789012345-6',
          },
          {
            royaltyEntity: 'ABRAMUS_DIGITAL',
            cwrId: 'D-543210987-5',
          },
        ],
        iswc: 'T-567.890.123-4',
        explicit: false,
        associatedTracks: [
          {
            id: 901,
            isrc: 'USGF19942502',
            hash: '',
            title: 'Smells Like Teen Spirit',
            titleVersion: 'Album Version',
            primaryGenre: {
              id: 15,
              name: 'Rock',
            },
            secondaryGenre: {
              id: 50,
              name: 'Grunge',
            },
            label: {
              id: 30,
              imageId: 'dgc-records-001',
              name: 'DGC Records',
              description: 'Universal Music Group',
            },
            releaseDate: '1991-09-10',
            artistNames: 'Nirvana',
            releaseType: 'ALBUM',
            status: 'READY',
          },
        ],
        rightsSaleStatus: {
          total: 1,
          ready: 0,
          inInspection: 1,
          processing: 0,
          scheduledToDrop: 0,
          primaryMarket: 0,
          secondaryMarket: 0,
          failed: 0,
          sales: [],
          status: null,
        },
        publishingStatus: {
          execution: [
            {
              cwrId: 'W-789012345-6',
              royaltyEntity: 'ABRAMUS',
              iconUrl: 'abramus-icon-hash',
              scope: 'BR',
              status: 'REGISTRATION_IN_PROGRESS',
              lastUpdateAt: '2025-10-04T18:45:00Z',
            },
          ],
          streamingPublishingShare: [
            {
              cwrId: 'D-543210987-5',
              royaltyEntity: 'ABRAMUS_DIGITAL',
              scope: 'BR',
              status: 'REGISTRATION_IN_PROGRESS',
              lastUpdateAt: '2025-10-04T18:45:00Z',
            },
          ],
          status: 'REGISTRATION_IN_PROGRESS',
        },
      },
      {
        id: 10,
        title: 'Purple Rain',
        composerNames: 'Prince Rogers Nelson',
        societyRegistrations: [
          {
            royaltyEntity: 'ECAD',
            cwrId: 'T-678.901.234-5',
          },
          {
            royaltyEntity: 'ABRAMUS',
            cwrId: 'W-890123456-7',
          },
        ],
        iswc: 'T-678.901.234-5',
        explicit: false,
        associatedTracks: [
          {
            id: 1001,
            isrc: 'USWB19984012',
            hash: '',
            title: 'Purple Rain',
            titleVersion: 'Album Version',
            primaryGenre: {
              id: 22,
              name: 'Pop',
            },
            secondaryGenre: {
              id: 15,
              name: 'Rock',
            },
            label: {
              id: 35,
              imageId: 'warner-bros-001',
              name: 'Warner Bros. Records',
              description: 'Warner Music Group',
            },
            releaseDate: '1984-06-25',
            artistNames: 'Prince and The Revolution',
            releaseType: 'ALBUM',
            status: 'READY',
          },
          {
            id: 1002,
            isrc: 'USWB19984013',
            hash: '',
            title: 'Purple Rain',
            titleVersion: 'Single Edit',
            primaryGenre: {
              id: 22,
              name: 'Pop',
            },
            secondaryGenre: {
              id: 15,
              name: 'Rock',
            },
            label: {
              id: 35,
              imageId: 'warner-bros-002',
              name: 'Warner Bros. Records',
              description: '7-inch single',
            },
            releaseDate: '1984-09-26',
            artistNames: 'Prince and The Revolution',
            releaseType: 'SINGLE',
            status: 'READY',
          },
        ],
        rightsSaleStatus: {
          total: 2,
          ready: 2,
          inInspection: 0,
          processing: 0,
          scheduledToDrop: 0,
          primaryMarket: 1,
          secondaryMarket: 1,
          failed: 0,
          sales: [],
          status: null,
        },
        publishingStatus: {
          execution: [
            {
              cwrId: 'W-890123456-7',
              royaltyEntity: 'ABRAMUS',
              iconUrl: 'abramus-icon-hash',
              scope: 'BR',
              status: 'ACTIVE',
              lastUpdateAt: '2025-01-20T12:00:00Z',
            },
          ],
          streamingPublishingShare: [],
          status: 'ACTIVE',
        },
      },
      {
        id: 11,
        title: 'Wonderwall',
        composerNames: 'Noel Gallagher',
        societyRegistrations: [
          {
            royaltyEntity: 'ECAD',
            cwrId: 'T-789.012.345-6',
          },
          {
            royaltyEntity: 'ABRAMUS',
            cwrId: 'W-901234567-8',
          },
          {
            royaltyEntity: 'ABRAMUS_DIGITAL',
            cwrId: 'D-432109876-6',
          },
        ],
        explicit: false,
        associatedTracks: [
          {
            id: 1101,
            isrc: 'GBAYE9500505',
            hash: '',
            title: 'Wonderwall',
            titleVersion: 'Album Version',
            primaryGenre: {
              id: 15,
              name: 'Rock',
            },
            secondaryGenre: {
              id: 52,
              name: 'Britpop',
            },
            label: {
              id: 40,
              imageId: 'creation-records-001',
              name: 'Creation Records',
              description: 'Indie label',
            },
            releaseDate: '1995-10-02',
            artistNames: 'Oasis',
            releaseType: 'ALBUM',
            status: 'READY',
          },
        ],
        rightsSaleStatus: {
          total: 1,
          ready: 0,
          inInspection: 0,
          processing: 1,
          scheduledToDrop: 0,
          primaryMarket: 0,
          secondaryMarket: 0,
          failed: 0,
          sales: [],
          status: null,
        },
        publishingStatus: {
          execution: [
            {
              cwrId: 'W-901234567-8',
              royaltyEntity: 'ABRAMUS',
              iconUrl: 'abramus-icon-hash',
              scope: 'BR',
              status: 'WORK_REGISTRATION_IN_PROGRESS',
              lastUpdateAt: '2025-10-04T21:10:00Z',
            },
          ],
          streamingPublishingShare: [
            {
              cwrId: 'D-432109876-6',
              royaltyEntity: 'ABRAMUS_DIGITAL',
              scope: 'BR',
              status: 'WORK_REGISTRATION_IN_PROGRESS',
              lastUpdateAt: '2025-10-04T21:10:00Z',
            },
          ],
          status: 'WORK_REGISTRATION_IN_PROGRESS',
        },
      },
      {
        id: 12,
        title: "Sweet Child O' Mine",
        composerNames: 'Slash x Axl Rose x Izzy Stradlin',
        societyRegistrations: [
          {
            royaltyEntity: 'ECAD',
            cwrId: 'T-890.123.456-7',
          },
          {
            royaltyEntity: 'ABRAMUS',
            cwrId: 'W-012345678-9',
          },
        ],
        iswc: 'T-890.123.456-7',
        explicit: false,
        associatedTracks: [
          {
            id: 1201,
            isrc: 'USGF18700134',
            hash: '',
            title: "Sweet Child O' Mine",
            titleVersion: 'Album Version',
            primaryGenre: {
              id: 15,
              name: 'Rock',
            },
            secondaryGenre: {
              id: 33,
              name: 'Hard Rock',
            },
            label: {
              id: 45,
              imageId: 'geffen-records-002',
              name: 'Geffen Records',
              description: 'Universal Music Group',
            },
            releaseDate: '1987-07-21',
            artistNames: "Guns N' Roses",
            releaseType: 'ALBUM',
            status: 'READY',
          },
        ],
        rightsSaleStatus: {
          total: 1,
          ready: 1,
          inInspection: 0,
          processing: 0,
          scheduledToDrop: 0,
          primaryMarket: 1,
          secondaryMarket: 0,
          failed: 0,
          sales: [],
          status: null,
        },
        publishingStatus: {
          execution: [
            {
              cwrId: 'W-012345678-9',
              royaltyEntity: 'ABRAMUS',
              iconUrl: 'abramus-icon-hash',
              scope: 'BR',
              status: 'ACTIVE',
              lastUpdateAt: '2024-11-05T14:25:00Z',
            },
          ],
          streamingPublishingShare: [],
          status: 'ACTIVE',
        },
      },
      {
        id: 13,
        title: 'Nothing Else Matters',
        composerNames: 'James Hetfield x Lars Ulrich feat. Metallica',
        societyRegistrations: [
          {
            royaltyEntity: 'ECAD',
            cwrId: 'T-901.234.567-8',
          },
        ],
        iswc: 'T-901.234.567-8',
        explicit: false,
        associatedTracks: [
          {
            id: 1301,
            isrc: 'USEE19100551',
            hash: '',
            title: 'Nothing Else Matters',
            titleVersion: 'Album Version',
            primaryGenre: {
              id: 55,
              name: 'Metal',
            },
            secondaryGenre: {
              id: 15,
              name: 'Rock',
            },
            label: {
              id: 50,
              imageId: 'elektra-records-001',
              name: 'Elektra Records',
              description: 'Warner Music Group',
            },
            releaseDate: '1991-08-12',
            artistNames: 'Metallica',
            releaseType: 'ALBUM',
            status: 'READY',
          },
        ],
        rightsSaleStatus: {
          total: 1,
          ready: 1,
          inInspection: 0,
          processing: 0,
          scheduledToDrop: 0,
          primaryMarket: 0,
          secondaryMarket: 0,
          failed: 0,
          sales: [],
          status: null,
        },
        publishingStatus: {
          execution: [],
          streamingPublishingShare: [],
          status: 'INACTIVE',
        },
      },
      {
        id: 14,
        title: 'Hallelujah',
        composerNames: 'Leonard Cohen',
        societyRegistrations: [
          {
            royaltyEntity: 'ECAD',
            cwrId: 'T-012.345.678-9',
          },
          {
            royaltyEntity: 'ABRAMUS',
            cwrId: 'W-123456780-0',
          },
          {
            royaltyEntity: 'ABRAMUS_DIGITAL',
            cwrId: 'D-321098765-7',
          },
        ],
        iswc: 'T-012.345.678-9',
        explicit: false,
        associatedTracks: [
          {
            id: 1401,
            isrc: 'USSM19800142',
            hash: '',
            title: 'Hallelujah',
            titleVersion: 'Original Version',
            primaryGenre: {
              id: 58,
              name: 'Folk',
            },
            secondaryGenre: {
              id: 22,
              name: 'Pop',
            },
            label: {
              id: 55,
              imageId: 'columbia-records-002',
              name: 'Columbia Records',
              description: 'Sony Music',
            },
            releaseDate: '1984-12-11',
            artistNames: 'Leonard Cohen',
            releaseType: 'ALBUM',
            status: 'READY',
          },
          {
            id: 1402,
            isrc: 'USSM19940143',
            hash: '',
            title: 'Hallelujah',
            titleVersion: 'Jeff Buckley Cover',
            primaryGenre: {
              id: 60,
              name: 'Alternative',
            },
            secondaryGenre: {
              id: 15,
              name: 'Rock',
            },
            label: {
              id: 58,
              imageId: 'columbia-records-003',
              name: 'Columbia Records',
              description: 'Cover version',
            },
            releaseDate: '1994-08-23',
            artistNames: 'Jeff Buckley',
            releaseType: 'ALBUM',
            status: 'READY',
          },
        ],
        rightsSaleStatus: {
          total: 2,
          ready: 1,
          inInspection: 0,
          processing: 0,
          scheduledToDrop: 0,
          primaryMarket: 0,
          secondaryMarket: 1,
          failed: 1,
          sales: [],
          status: 'ERROR',
        },
        publishingStatus: {
          execution: [
            {
              cwrId: 'W-123456780-0',
              royaltyEntity: 'ABRAMUS',
              iconUrl: 'abramus-icon-hash',
              scope: 'BR',
              status: 'UPDATE_FAILED',
              lastUpdateAt: '2025-09-30T17:40:00Z',
            },
          ],
          streamingPublishingShare: [
            {
              cwrId: 'D-321098765-7',
              royaltyEntity: 'ABRAMUS_DIGITAL',
              scope: 'BR',
              status: 'UPDATE_FAILED',
              lastUpdateAt: '2025-09-30T17:40:00Z',
            },
          ],
          status: 'UPDATE_FAILED',
        },
      },
      {
        id: 15,
        title: 'Thriller',
        composerNames: 'Rod Temperton',
        societyRegistrations: [
          {
            royaltyEntity: 'ECAD',
            cwrId: 'T-123.456.780-0',
          },
          {
            royaltyEntity: 'ABRAMUS',
            cwrId: 'W-234567801-1',
          },
        ],
        iswc: 'T-123.456.780-0',
        explicit: false,
        associatedTracks: [
          {
            id: 1501,
            isrc: 'USSM18200564',
            hash: '',
            title: 'Thriller',
            titleVersion: 'Album Version',
            primaryGenre: {
              id: 22,
              name: 'Pop',
            },
            secondaryGenre: {
              id: 62,
              name: 'Funk',
            },
            label: {
              id: 15,
              imageId: 'epic-records-003',
              name: 'Epic Records',
              description: 'Thriller album',
            },
            releaseDate: '1982-11-30',
            artistNames: 'Michael Jackson',
            releaseType: 'ALBUM',
            status: 'READY',
          },
        ],
        rightsSaleStatus: {
          total: 1,
          ready: 0,
          inInspection: 1,
          processing: 0,
          scheduledToDrop: 0,
          primaryMarket: 0,
          secondaryMarket: 0,
          failed: 0,
          sales: [],
          status: null,
        },
        publishingStatus: {
          execution: [
            {
              cwrId: 'W-234567801-1',
              royaltyEntity: 'ABRAMUS',
              iconUrl: 'abramus-icon-hash',
              scope: 'BR',
              status: 'UPDATE_IN_PROGRESS',
              lastUpdateAt: '2025-10-04T19:55:00Z',
            },
          ],
          streamingPublishingShare: [],
          status: 'UPDATE_IN_PROGRESS',
        },
      },
    ],
    totalPages: 1,
    totalElements: 5,
    last: false,
    size: 10,
    number: 0,
    numberOfElements: 5,
    first: true,
    empty: false,
  } as any,
  error: {
    error: '',
    title: '',
    code: '',
    trace: '',
    modal: false,
  },
  errors: [
    {
      error: '',
      title: '',
      code: '',
      trace: '',
      modal: false,
    },
  ],
  page: 0,
  metadata: {
    additionalProp1: {},
    additionalProp2: {},
    additionalProp3: {},
  },
  total_pages: 1,
  per_page: 10,
  total_items: 5,
} as any;
